<template>
  <div class="body-title">
    <h2>Assisting Seniors with Physical or Cognitive Difficulties</h2>
  </div>

  <div class="body-grid-container">

    <div class="left-container">

      <div class="left-top-container">
        <div>
          <img class="left-top-pics" src="../assets/HomeBodyTop.jpg">
        </div>

        <div class="left-top-text">
          <p>WMADCC is a licensed healthcare facility that offers medical and recreational care to individuals who have been diagnosed with physical or cognitive impairments. Our team of experts create a holistic care plan for each client to ensure that specific needs are met. We relieve caregivers by providing a safe and fun community environment for your loved ones so that they can remain in the comfort of their own homes.</p>
        </div>
      </div>

      <div class="left-bottom-container">
        <div>
          <img class="left-bottom-pics" src="../assets/HomeBodyBottom.jpg">
        </div>

        <div class="left-bottom-text">
          <p>Individuals who are eligible through Medicaid or the Veterans Administration will receive coverage at absolutely no cost. We also accept private payment for interested families. Our goal is to provide convenient, cost-effective solutions to help our clients lead successful and fulfilling lives.</p>
        </div>
      </div>
    </div>

    <div class="right-container">
      <div class="right-text-title">
        <p>Complimentary Services</p>
      </div>

      <div class="right-container-text">
        <li> Daily Health Monitoring</li>
        <li>Nutritious Meals</li>
        <li>Social Services</li>
        <li>Door-to-Door Transportation</li>
        <li>Transport to/from Doctor's Appts.</li>
        <li>Recreation and Activities</li>
        <li>Daily Exercises</li>
        <li>Arts & Crafts</li>
        <li>Religious Activities</li>
        <li>Cultural Event</li>
        <li>Wi-fi & Internet Access</li>
      </div>

      <div>
        <img class="right-container-pics" src="../assets/HomeBodyRight.jpg">
      </div>

    </div>
  </div>

  <div class="footer-grid-container">
    <div class="footer-left-text">
      <p>6501 Poplar Ave.</p>
      <p>Tacoma Park, MD 20912</p>
      <p>(667) 200-6325</p>
    </div>

    <div class="footer-right-text">
      <p>Copy Right reserved </p>
      <p>for WMADCC</p>
    </div>
  </div>

</template>
  
<script>

  export default {
    name: 'HomeBody'
  }

</script>
  
<style scoped>

/* for desktop */
@media (min-width:701px) {

  .body-title {
    text-align: center;
    font-size: 1.5vw;
    color: darkblue;
  }

  .body-grid-container {
    display: grid;
    grid-template-columns: 2.5fr 1fr;
  }

  .left-container {
    display: grid;
    grid-template-rows: 1fr 1fr;
  }

  .left-top-container {
    display: grid;
    place-items: center;
    grid-template-columns: 1.5fr 2fr;
    border-top: 1px solid lightslategray;
    background-color: rgb(250, 250, 250);

  }

  .left-top-pics, .left-bottom-pics {
    width: 21vw;
    height: 21vw;
    border: 5px solid #fff;
    box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.5);
    margin-left: -2vw;
  }

  .left-top-text, .left-bottom-text {
    place-items: center;
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: lighter;
    line-height: 2.5vw;
    margin-left: -1vw;
    margin-right: 2.5vw;
    padding: 0.5vw;
  }

  .left-bottom-container {
    display: grid;
    place-items: center;
    grid-template-columns: 1.5fr 2fr;
    border-top: 1px solid lightslategray;
    background-color: rgb(250, 250, 250);
  }

  .right-container {
    display: grid;
    place-items: center;
    grid-template-rows: 5fx 1fx;
    background-color: rgb(238, 238, 238);
    border-top: 1px solid gray;
  }

  .right-text-title {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-weight: bold;
    font-size: 1.3rem;
    margin-top: 1.5vw;
  }
     
  .right-container-text {
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    line-height: 2.5rem;
    margin-left: 3vw;
  }

  .right-container-pics {
    width: 28vw;
    height: 17vw;
    border: 5px solid #fff;
    box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.5);
    margin-top: 2vw;
    margin-left: 1vw;    
  }
 
  .footer-grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 1vw;
    background-color: rgb(238, 238, 238);
    border: 1px solid gray;
  }

 .footer-left-text {
    text-align: left;
    justify-content: left;
    color: darkblue;
    font-style: optima;
    line-height: 0.3rem;
    font-size: 1.2rem;
    font-weight: bold;;
    margin-top: 0.3vw;
    margin-left: 1vw;
  }

 .footer-right-text {
    text-align: right;
    justify-content: right;
    color: darkblue;
    font-style: optima;
    font-weight: bold;
    font-size: 1rem;
    line-height: 0.1rem;
    margin-top: 0.3vw;
    margin-right: 1vw;
  }
}


/* for Phone */
@media (max-width:700px) {
  .body-title {
    text-align: center;
    font-size: 3vw;
    color: darkblue;
  }

  .left-top-pics {
    width: 15rem;
    height: 10rem;
  }

  .left-top-text {
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 3.5vw;
    height: auto;
    justify-content: top left;
  }

  .left-bottom-pics {
    width: 15rem;
    height: 10rem;

  }

  .left-bottom-text {
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 3.5vw;
    height: auto;
    justify-content: top left;
  }

  .right-text-title {
    color: darkblue;
    text-align: center;
    font-style: optima;
    font-weight: bold;
    font-size: 4vw;
  }
     
  .right-container-text {
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 3.5vw;
    height: auto;
    line-height: 1.7rem;
    justify-content: left;
    margin-left: 4rem;
  }

  .right-container-pics {
    width: 15rem;
    height: 10rem;
    margin-top: 1rem;  
  } 

 .footer-left-text {
    text-align: left;
    justify-content: left;
    color: darkblue;
    font-style: optima;
    height: auto;
    font-size: 3.5vw;
    line-height: 0.3rem;
    font-weight: bold;
  }

 .footer-right-text {
    text-align: right;
    justify-content: right;
    color: darkblue;
    font-style: optima;
    font-weight: bold;
    font-size: 3vw;
    line-height: 0.3rem;
  }
}

</style>